// ============================================================================
// ui/sample.js — the "never show an empty designer" seed (V2 plan §4)
// ============================================================================
// First frame is a FINISHED branded example (a fictional school), never a
// default-gray plate. Also powers the "Try it with a sample logo" secondary CTA.
// Pure data + a tiny inline-SVG monogram (self-contained data URL — no network,
// respects the CSP isolation contract).
// ============================================================================

import { createDefaultProfile } from '../design-profile.js';
import { applyLayoutPreset } from '../layouts.js';

/** Inline SVG monogram used as the demo/sample logo (transparent, square). */
const SAMPLE_LOGO_SVG =
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">` +
  `<path d="M50 6 88 24 88 58 Q88 84 50 96 Q12 84 12 58 L12 24 Z" fill="#FFFFFF"/>` +
  `<path d="M50 6 88 24 88 58 Q88 84 50 96 Q12 84 12 58 L12 24 Z" fill="none" stroke="#0B1B33" stroke-width="4"/>` +
  `<text x="50" y="62" text-anchor="middle" font-family="Georgia, 'Times New Roman', serif" ` +
  `font-size="42" font-weight="700" fill="#0B1B33">N</text>` +
  `<path d="M28 70 H72" stroke="#0B1B33" stroke-width="3"/></svg>`;

/** data: URL for the sample monogram (base64 keeps it inert in SVG href). */
export const SAMPLE_LOGO_DATA_URL =
  'data:image/svg+xml;base64,' +
  (typeof btoa !== 'undefined'
    ? btoa(SAMPLE_LOGO_SVG)
    : Buffer.from(SAMPLE_LOGO_SVG).toString('base64'));

/** The logo sub-object for the "Try it with a sample logo" CTA. */
export function sampleLogo() {
  return {
    dataUrl: SAMPLE_LOGO_DATA_URL,
    fileName: 'sample-monogram.svg',
    mimeType: 'image/svg+xml',
    width: 100,
    height: 100,
    aspectRatio: 1,
    isVector: true,
    quality: 'high',
    transparentBg: true,
  };
}

/** The fictional-school demo profile shown on first paint (element model). */
export function createDemoProfile() {
  const p = createDefaultProfile();
  p.palette = { primary: '#0B4DA2', secondary: '#F2C14E', tertiary: null };
  applyLayoutPreset(p, 'logo-l-weight-r-arch-tb');
  const top = p.elements.find((e) => e.type === 'arctext' && e.slot === 'top');
  if (top) top.text = 'NORTHGATE';
  const bottom = p.elements.find((e) => e.type === 'arctext' && e.slot === 'bottom');
  if (bottom) bottom.text = 'ACADEMY';
  const logo = p.elements.find((e) => e.type === 'logo');
  if (logo) logo.logo = sampleLogo();
  return p;
}
